import { createStore } from 'effector'

export enum Device {
    Mobile,
    Desktop
}

export const $device = createStore<Device>(Device.Desktop)
